/**
 * R-15 — versioned prompt template for citation-supports-claim judge.
 */
export const CITATION_SUPPORT_JUDGE_PROMPT_VERSION = '2026-05-26.v1';

export interface CitationSupportJudgeInput {
  claimText: string;
  sourceText: string;
  sourceLabel: string;
  refIndex: number;
  sectionId: string;
}

export function buildCitationSupportJudgePrompt(input: CitationSupportJudgeInput): string {
  return [
    `Prompt version: ${CITATION_SUPPORT_JUDGE_PROMPT_VERSION}`,
    'You are a report QA auditor. Judge whether the CITED SOURCE excerpt supports the CLAIM',
    'made in an investment-grade site feasibility report.',
    '',
    'Return JSON only with fields:',
    '- verdict: "SUPPORTED" | "UNSUPPORTED" | "CONTRADICTED" | "PARTIAL"',
    '- rationale: one concise sentence explaining the verdict',
    '',
    'Verdict rubric:',
    '- SUPPORTED: the source reasonably substantiates the claim (values, facts, or characterization)',
    '- UNSUPPORTED: source is missing, unrelated, or too thin to support the claim',
    '- CONTRADICTED: source directly contradicts a numeric or factual assertion in the claim',
    '- PARTIAL: source supports part of the claim but omits or weakens a material assertion',
    '',
    `Section: ${input.sectionId}`,
    `Reference: [Ref ${input.refIndex}] ${input.sourceLabel}`,
    '',
    'CLAIM:',
    input.claimText,
    '',
    'CITED SOURCE EXCERPT:',
    input.sourceText.slice(0, 4000) || '(no source excerpt available)',
  ].join('\n');
}
